export default "__VITE_ASSET__Bwi5rsvT__"